// @flow

import React, { type Node, useEffect } from 'react';

import { IfFeature, type Feature } from '@tectonics/prs/feature';
import { useUserInputValue } from '@tectonics/prs/user-input-values';

import { AchPseBankList } from './bank-list';
import { AchPseAddressStreetName } from './achpse-address-street-name';

type Props = {
  allFeatures: ImmutableArray<Feature>,
};

export function AchPseForm({ allFeatures }: Props): Node {
  const [selectedExternalPayProvider, setSelectedExternalPayProvider] = useUserInputValue('selectedExternalPayProvider');

  useEffect(() => {
    setSelectedExternalPayProvider('achpse');
  }, [selectedExternalPayProvider]);

  return (
    <>
      <IfFeature allFeatures={allFeatures} wanted="field_colombian_address">
        <AchPseAddressStreetName />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_externalpayprovider_bank_list">
        <AchPseBankList />
      </IfFeature>
    </>
  );
}
